import { mappingColumn } from './ClvrScreenControlRowCombineDatas'
import { ClvrScreenControlHeadersEnumRefLabelsType } from '../type'
import { Undefinable, Nullable } from '@internal-libraries/kheops-ui-lib'
import { ScreenControlDataTypeData } from '../../../Types/ScreenControlDataTypeData'

/**
 *
 * @param name ( can be a simple column like the surgeon or a combined column, example of materials and remarks )
 * @param dataType
 */
export const createHeader = (
    id: number,
    name: string,
    dataType: ScreenControlDataTypeData,
): ScreenControlDataTypeData => {
    return {
        id,
        name,
        rank: dataType?.rank,
        align: 'start',
        sortable: false,
        enable: dataType.enable,
        children: dataType.dataTypeChildren
            ?.map(child => (child.id ? createHeader(child.id, child.name, child) : null))
            .filter(Boolean),
        parentDataTypeId: null,
    } as ScreenControlDataTypeData
}

export const combineColumn = (
    id: number,
    dataType: ScreenControlDataTypeData,
    headerName: string,
    headers: ScreenControlDataTypeData[],
    refLabels: ClvrScreenControlHeadersEnumRefLabelsType,
): Undefinable<ScreenControlDataTypeData> => {
    const combineColumn: Nullable<string> = mappingColumn(headerName, refLabels)
    const combinedColumn: ScreenControlDataTypeData | undefined = headers.find(header => header.name === combineColumn)
    // check if the combined column is already added in the headers it can only be added once
    if (combinedColumn) return
    return createHeader(id, combineColumn ?? headerName, dataType)
}
